import { render } from "./text-input.vue?vue&type=template&id=2f2ee9d0&scoped=true"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"

import "./text-input.vue?vue&type=style&index=0&id=2f2ee9d0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2ee9d0"]])

export default __exports__